import React from 'react';

import data from 'emoji-mart/data/apple.json';
import NimbleEmoji, { NimbleEmojiProps } from 'emoji-mart/dist-es/components/emoji/nimble-emoji';

export default function Emoji(props: Omit<NimbleEmojiProps, 'data' | 'native'>) {
    return props.emoji ? <NimbleEmoji native data={data} {...props} /> : null;
}
